// AddButton.tsx   ← feel free to rename as needed
import React from 'react';
import { Icons } from '../../icons';

interface Props {
  responsive?: boolean;
  collapsed?: boolean;
  onClick?: () => void;
}

const TicketResolvedButton: React.FC<Props> = ({
  responsive = false,
  collapsed = false,
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      type='button'
      className='p-2 flex items-center justify-center bg-[#FF0050] text-white hover:bg-[#ff0051d7] transition-colors rounded-lg'
    >
      {/* <Icons.Plus className='h-6 w-6 lg:h-8 lg:w-8' fill='white' /> */}

      {/* label only when sidebar open */}
      <span
        className={`${
          responsive && collapsed ? 'hidden lg:block' : ''
        } xl:ml-2 lg:text-sm xl:text-[18px]`}
      >
        Resolved
      </span>
    </button>
  );
};

export default TicketResolvedButton;
